import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { AppLocale, BAND_NAME, BAND_NAME_JP, ButtonsSizes, SITE_NAME } from 'constant';

import { LanguageContext } from 'context/languageContext';

import Container from 'components/Container';
import Title from 'components/ui/Title';

import {
  Wrapper,
  StyledButton
} from './WorkInProgress.styles';

export interface WorkInProgressProps {
  className?: string;
}

const WorkInProgress = ({ className = '' }: WorkInProgressProps) => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  const sowFromStorage = sessionStorage.getItem('showWIP');
  const [show, setShow] = React.useState<boolean>(sowFromStorage !== 'hide');

  return show ? (
    <Wrapper className={className}>
      <Container>
        <Title size="small" color="white">
          {intl.formatMessage({ id: 'workInProgress.disclaimer.title' })}
        </Title>
        <p>
          {intl.formatMessage({ id: 'workInProgress.disclaimer.description1' }, {
            bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP,
            bold: <b>{intl.formatMessage({ id: 'workInProgress.disclaimer.bold' }, { siteName: SITE_NAME })}</b>
          })}
        </p>
        <p>
          {intl.formatMessage({ id: 'workInProgress.disclaimer.description2' })}
        </p>
        <StyledButton
          size={ButtonsSizes.Small}
          onClick={() => {
            sessionStorage.setItem('showWIP', 'hide');
            setShow(false);
          }}
        >
          Close
        </StyledButton>
      </Container>
    </Wrapper>
  ) : null;
};

export default WorkInProgress;
